module.exports = __webpack_public_path__ + "static/img/AL@3x.e1084652.png";